export default {
  superUserManuelAccountCollects(state) {
    return state.superUserManuelAccountCollects;
  },
};
